import { memo, useMemo } from 'react';

import { SortableHeader } from '~/components/TableView/SortableHeader';
import { NAME_HEADER } from '~/constants/testIDs';
import { useTableView } from '../TableViewContext';
import { makeActiveTableColumnFromOption } from '../tableColumnWidthsUtils';

export const NameHeader = memo(() => {
  const { getColumnWidthStyle, getHeaderResizeHandle } = useTableView();

  const optionColumn = useMemo(() => makeActiveTableColumnFromOption('title', false, undefined), []);
  const columnWidthStyle = useMemo(() => getColumnWidthStyle(optionColumn), [getColumnWidthStyle, optionColumn]);
  const resizeHandle = useMemo(() => getHeaderResizeHandle(optionColumn), [getHeaderResizeHandle, optionColumn]);

  return (
    <SortableHeader
      title="Name"
      sortingType="name"
      data-testid={NAME_HEADER}
      // add negative margin to align 'name' text in button with image in table row
      className="-ml-4"
      style={columnWidthStyle}
      resizeHandle={resizeHandle}
    />
  );
});

NameHeader.displayName = 'NameHeader';
